export const siteName = "火影忍者动漫频道";

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "剧集", to: "/episodes" },
  { label: "角色", to: "/characters" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];